module.exports = ":host {\n    display: block;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin/admin.component.css
// module id = ./src/app/admin/admin/admin.component.css
// module chunks = main